export default "__VITE_ASSET__hfJvHn6e__"